import {
  type PaymentPopupInfo as PaymentPopupInfoType,
  type PaymentsReservation as PaymentsReservationType,
} from './Payments';

interface WindowMessageBase {
  type: WindowMessageType;
}

export enum WindowMessageType {
  PurchaseComplete = 'PurchaseComplete',
  PaymentPopupInfo = 'PaymentPopupInfo',
  PaymentsReservation = 'PaymentsReservation',
  Ack = 'MessageAck',
}

export interface PurchaseCompleteMessage extends WindowMessageBase {
  type: WindowMessageType.PurchaseComplete;

  /**
   * 모듈이 아닌 GemProduct일 경우 undefined 처리
   * @TODO 모든 상품이 모듈화되는 경우 required로 변경
   */
  productModuleType?: string;
}

export interface PaymentPopupInfoMessage {
  type: WindowMessageType.PaymentPopupInfo;
  paymentPopupInfo: PaymentPopupInfoType;
}

export interface PaymentsReservationMessage extends WindowMessageBase {
  type: WindowMessageType.PaymentsReservation;
  reservation: PaymentsReservationType | null;
  errorCode?: string;
}

export interface AckMessage extends WindowMessageBase {
  type: WindowMessageType.Ack;
  respondingTo: Exclude<WindowMessageType, WindowMessageType.Ack>;
}

export type WindowMessage =
  | PurchaseCompleteMessage
  | PaymentPopupInfoMessage
  | PaymentsReservationMessage
  | AckMessage;

export const isCustomWindowMessage = (message: MessageEvent['data']): message is WindowMessage => {
  return Object.values(WindowMessageType).includes(message?.type);
};

export const isCustomWindowMessageOfType = <K extends WindowMessageType>(
  message: MessageEvent['data'],
  type: K
): message is Extract<WindowMessage, { type: K }> => {
  return message?.type === type;
};
